<template>
  <div v-if="stockData && stockData.stockNum>0" class="card-list" :id="type+i">
    <div class="list-title mb16">
      <span>{{`${stockData.houseFloorNumber}层`}}</span>
      <div class="fr">
        <span class="num">{{stockData.stockNum}}</span>
        <Icon class="arrow" type="ios-arrow-down" style="font-size:20px; vertical-align:middle;"
              @click.native="toggle"/>
      </div>
    </div>
    <Row :gutter="12" class="cards">
      <Col v-for="(item,i) in stockData.subStockList" style="min-width:280px" :key="i" span="12" :md="8" :lg="6">
        <card :cardData="item" @send-invitations="sendInvitations"
              @personbook="personbook" :projectFid="projectFid" :rentType="rentType"
        ></card>
      </Col>
    </Row>
    <invitation-modal :n="invitationKey" :stockNumber="stockNumber" :cityCode="cityCode"
                      :signInviteInfo="signInviteInfo"></invitation-modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import {addClass, removeClass} from '@/utils/tool'
  import Card from './Card';
  import InvitationModal from './InvitationModal'
  import {getSignInviteInfo} from "api/signInvite"

  export default {
    props: {
      type: {
        type: String,
        default: ''
      },
      i: {
        type: Number,
        default: 0
      },
      stockData: {
        type: Object,
        default: null
      },
      cityCode: {
        type: String,
        default: ''
      },
      projectFid: {
        type: String,
        default: '',
      },
      rentType: {
        type: Number,
        default: 0,
      }
    },
    components: {
      Card,
      InvitationModal
    },
    data() {
      return {
        invitationKey: 0,
        isClick: false,
        signInviteInfo: null,
        stockNumber: ''
      };
    },
    methods: {
      personbook(cardData) {
        this.$emit('personbook', {...cardData})
      },
      toggle() {
        this.isClick = !this.isClick
        let id = this.type + this.i
        let dom = document.getElementById(id)
        if (this.isClick) {
          addClass(dom, 'active')
        } else {
          removeClass(dom, 'active')
        }
      },
      sendInvitations(data) {
        // 调接口
        getSignInviteInfo(data.stockFid).then(res => {
          this.signInviteInfo = res.data
          console.log(this.signInviteInfo)
          this.stockNumber = data.stockNumber
          this.invitationKey++
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .card-list {
    /* flex: 1;*/
    padding-left: 18px;
    padding-right: 18px;
  }

  .num {
    display: inline-block;
    background: #CFA868;
    margin-right: 10px;
    width: 21px;
    line-height: 21px;
    font-size: 12px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
  }

  .active .arrow {
    transform: rotate(180deg);

  }

  .arrow {
    transition: .5s ease;
    cursor: pointer;
  }

  .card-list {
    transition: 5s ease;

  }

  .active .cards {
    height: 148px;
    overflow: hidden;
  }

</style>
